export const environment = {
  production: true,
  loginUrl: '/login',
  url: 'https://cisr.stg.simadvisory.com',
  // API_URL: `http://54.204.112.128:8084`,
  // API_URL: `https://cisr.stg.simadvisory.com`,
  API_URL: `/app`,
  // ACCESS_API_URL: `http://localhost:8082`,
  ACCESS_API_URL: 'https://cisr.stg.simadvisory.com/app',
  KeycloakUrl: 'https://auth.simadvisory.com/auth',
  Realm: 'SRT_Stg',
  ClientId: 'S_SRT_Client',
  psbuSegmentationUrl: 'https://stg-psbu.alpha.simadvisory.com/',
  // Realm: 'development',
  // Realm: 'SRT_Dev',
  // ClientId: 'angular-client',
  // ClientId: 'D_SRT_Client',
  //KeycloakUrl:'http://localhost:8181/auth',
  //Realm:'SR Tool - Dev',
  //ClientId:'SRTool_Client',
  //KeycloakUrl:'http://localhost:8181/auth',
  //Realm:'SR Tool - Dev',
  //ClientId:'SRTool_Client',
  KEYCLOAK_EXTRA_ARGS_PREPENDED:
    '--spi-login-protocol-openid-connect-legacy-logout-redirect-uri=true',
  version: 'YTD - Oct 2024',
  version1: 'YTD - Sept 2024',
  version2: 'YTD - Oct 2024',
  version3: 'YTD - Oct 2024',
  version4: 'YTD - Sept 2024',
  version5: 'YTD - Oct 2024',
  meritorDateOfUpdate: 'Oct 2024',
  // version: 'vSR4.9',
  //  version1: 'v_EBU',
  //  version2:'v_CCNA_5.1',
  //  version3:'Powersys_5.0',
  //  version4:'v_overall_5.0',
  //  version5:'v_parts5.0',
  feedBackSubject: 'Feedback',
  toName: 'Praveen',
  //  production: true,
  //  loginUrl: '/login',
  //  API_URL: `/app`,
  //  version: 'vSR4.9',
  //  feedBackSubject: 'Feedback',
  //  toName: 'Praveen',
  NX_SUPERSET_DOMAIN: "https://reports.stg.cisr.alpha.simadvisory.com",
  NX_API_USER_ACCESS_URL: "https://cisr.stg.simadvisory.com/api/v1/user-access/reports/token",
  ID: "cb3415bd-48a8-4427-a26e-1e7b7769561c",
};
